import { render, staticRenderFns } from "./Objasnjenje.vue?vue&type=template&id=b84d197e&"
import script from "./Objasnjenje.vue?vue&type=script&lang=js&"
export * from "./Objasnjenje.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports